// extracted by mini-css-extract-plugin
export default {"degreesWrapper":"Degrees_degreesWrapper__Hf9ZO","degreesHead":"Degrees_degreesHead__t5b2F","degreesGrid":"Degrees_degreesGrid__Ysw2Q","gridEl":"Degrees_gridEl__OCEZA"};